import React, { useEffect, useState } from "react";
import Commongrid from "../../common/Commongrid";
import formatDateAndTime from "../../common/formatDateAndTime";
import { useNavigate } from "react-router-dom";

const Myexpenses = ({ selectedRow }) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [myExpenses, setMyExpenses] = useState([]);
  const getToday = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  const getOneYearAgo = () => {
    const date = new Date();
    date.setFullYear(date.getFullYear() - 1);
    return date.toISOString().split("T")[0];
  };

  const [filters, setFilters] = useState({
    fromDate: getOneYearAgo(),
    toDate: getToday(),
    calculationType: "vehicleIssues",
  });

  const getExpensesDetailAPI = async (vehicleId) => {
    let query = "";

    if (filters.calculationType) {
      query += `&calculationOn=[${filters.calculationType}]`;
    }
    if (filters.fromDate) {
      query += `&startDate=${filters.fromDate + "T" + "00:00"}`;
    }
    if (filters.toDate) {
      query += `&endDate=${filters.toDate + "T" + "23:59"}`;
    }

    try {
      const response = await fetch(
        `${apiUrl}/api/analytics/vehicle-expenses?vehicleId=${vehicleId}&dateFilterType=createdAt${query}`,
        {
          method: "GET",
        },
      );

      const data = await response.json();

      if (data?.statusCode === "0100") {
        setMyExpenses(data?.dataValues);
      }

      return data;
    } catch (error) {
      console.error("Error fetching NRK listings:", error);
    }
  };

  useEffect(() => {
    if (selectedRow) {
      getExpensesDetailAPI(selectedRow.id);
    }
  }, [selectedRow]);

  return (
    <>
      <div className="bg-blue-50 rounded-xl shadow-sm border border-gray-200 p-4 mb-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 items-end">
          {/* From Date */}
          <div className="flex flex-col gap-1">
            <label className="text-xs font-semibold text-gray-600">
              From Date
            </label>
            <input
              type="date"
              value={filters.fromDate}
              onChange={(e) =>
                setFilters({ ...filters, fromDate: e.target.value })
              }
              className="h-10 rounded-lg border border-gray-300 px-3 text-sm 
                   focus:outline-none focus:ring-2 focus:ring-blue-500 
                   focus:border-blue-500"
            />
          </div>

          {/* To Date */}
          <div className="flex flex-col gap-1">
            <label className="text-xs font-semibold text-gray-600">
              To Date
            </label>
            <input
              type="date"
              value={filters.toDate}
              onChange={(e) =>
                setFilters({ ...filters, toDate: e.target.value })
              }
              className="h-10 rounded-lg border border-gray-300 px-3 text-sm 
                   focus:outline-none focus:ring-2 focus:ring-blue-500 
                   focus:border-blue-500"
            />
          </div>

          {/* Issue Type */}
          <div className="flex flex-col gap-1">
            <label className="text-xs font-semibold text-gray-600">
              Calculate By
            </label>
            <select
              value={filters.calculationType}
              onChange={(e) =>
                setFilters({ ...filters, calculationType: e.target.value })
              }
              className="h-10 rounded-lg border border-gray-300 px-3 text-sm 
                   bg-white focus:outline-none focus:ring-2 
                   focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="">All</option>
              <option value="vehicleIssues">Vehcile Issue</option>
              {/* <option value="fuelLogs">Fuel Logs</option> */}
            </select>
          </div>

          {/* Action Buttons */}
          <div className="flex gap-2">
            <button
              onClick={() => getExpensesDetailAPI(selectedRow?.id)}
              className="h-10 px-4 rounded-lg bg-blue-600 text-white text-sm 
                   font-medium hover:bg-blue-700 transition"
            >
              Apply
            </button>

            <button
              onClick={() =>
                setFilters({ fromDate: "", toDate: "", calculationType: "" })
              }
              className="h-10 px-4 rounded-lg border border-black 
                   text-sm font-medium text-gray-700 
                   transition"
            >
              Clear
            </button>
          </div>
        </div>
      </div>
      
      <VehicleExpenseCard
        totalCost={myExpenses?.totalVehicleIssuesCost}
        title="Issue Expenses"
        cardBg="bg-red-50"
        badgeBg="bg-red-100"
        badgeText="text-red-600"
        amountText="text-red-700"
      />
    </>
  );
};

export default Myexpenses;

const VehicleExpenseCard = ({
  totalCost,
  title,
  cardBg,
  badgeBg,
  badgeText,
  amountText,
}) => {
  return (
    <div
      className={`${cardBg} rounded-xl shadow-md border border-gray-100 
      w-full max-w-sm mt-4 mb-4 mx-4 p-6 transition`}
    >
      <div className="flex items-center justify-between mb-4">
        {/* <h3 className="text-sm font-medium text-gray-600">Vehicle Expenses</h3> */}

        <span
          className={`${badgeBg} ${badgeText} 
          text-xs font-semibold px-1 py-1 rounded-full`}
        >
          {title}
        </span>
      </div>

      <div className="flex items-end gap-2">
        <p className={`text-3xl font-bold ${amountText}`}>₹{totalCost || 0}</p>
        <span className="text-sm text-gray-500 mb-1">total</span>
      </div>
    </div>
  );
};
